module.exports = __webpack_public_path__ + "img/moderator-question.6189f30d.svg";